import axios from 'axios';
import _ from 'lodash';
import { API } from '../../constants';
import { store } from '../../../configureStore';
import { blockAccessCampus, revokeAuthAction } from '../../../containers/Auth/actions';
import ReactGaEvent from '../../../react-ga-event';

let isRefreshing = false;
let retryLogin = false;
let failedQueue = [];

/** Define client */
const client = axios.create();

/** Process all queue of request */
const processQueue = (error) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

/** Refresh the access token with refresh token */
const refreshAccessToken = () => {
  const sessionString = localStorage.getItem('session');

  return client({
    baseURL: API.BASEURL,
    url: API.REFRESH_TOKEN,
    method: 'POST',
    headers: {
      Authorization: 'Basic bm92aWdvX3RlY25vY2FzYTpxMW01SEZWcyZRNDhaakBleUBpRQ===',
    },
    data: {
      refresh_token: JSON.parse(sessionString).refreshToken,
    },
  });
};

/** Update token in local storage */
const updateToken = (content) => {
  const accessToken = content.tokenId;
  const refreshToken = content.refresh_token;
  const user = content.username;

  if (accessToken && user && refreshToken) {
    const session = {
      user,
      accessToken: `${user}_${accessToken}`,
      refreshToken,
    };

    localStorage.setItem('session', JSON.stringify(session));
  }
};

/** Get authorization header */
export const getAuth = () => {
  const sessionString = localStorage.getItem('session');

  let auth;

  if (sessionString) {
    const session = JSON.parse(sessionString);
    auth = `${session.user}|${session.accessToken}`;
  }

  return auth;
};

/** Request interceptors */
client.interceptors.request.use((configuration) => {
  // Get default auth
  let auth = getAuth();

  // If auth is already defined and it's type Basic use it
  if (
    configuration.headers &&
    configuration.headers.Authorization &&
    configuration.headers.Authorization.includes('Basic')
  ) {
    auth = configuration.headers.Authorization;
  }

  return _.merge(configuration, {
    baseURL: API.BASEURL,
    headers: {
      Authorization: auth,
      'Access-Control-Max-Age': 1728000,
    },
  });
});

/** Request Wrapper with default success/error actions */
const request = (options) => {
  ReactGaEvent(options.url, _.get(options, 'data.method') || options.url, '');

  // If options.raw is true, return all response
  const onSuccess = (response) => (options.raw ? response : response.data);

  const onError = (error) => {
    const originalRequest = error.config;

    if (error.response) {
      if (error.response.status === 403 && error.response.data.detail === 'Access blocked to Campus') {
        store.dispatch(blockAccessCampus());
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // If I'm refreshing the token I send request to a queue
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then(() => client(originalRequest).then(onSuccess).catch(onError));
          // .catch((err) => err);
        }

        originalRequest._retry = true;
        isRefreshing = true;
        retryLogin = true;

        // If none of the above, refresh the token and process the queue
        return new Promise((resolve, reject) => {
          refreshAccessToken()
            .then(({ data }) => {
              updateToken(data);
              processQueue(null);
              resolve(client(originalRequest).then(onSuccess).catch(onError));
            })
            .catch(({ response }) => {
              processQueue(response);
              store.dispatch(revokeAuthAction());
              reject(response);

              if (
                retryLogin
                // response.data &&
                // response.data.detail &&
                // response.data.detail.includes('Token has been revoked')
              ) {
                retryLogin = false;
                window.location.replace(window.location.href);
              }
            })
            .then(() => {
              isRefreshing = false;
            });
        });
      }
    }

    return Promise.reject(error.response || error.message);
  };

  // In realtà non catcho un bel niente perchè ritorno Promise.reject e quindi il giro ricomincia
  return client(options).then(onSuccess).catch(onError);
};

export default request;



// WEBPACK FOOTER //
// ./app/shared/lib/request/index.js